import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { AgentDto, DynamicFormDto, DynamicPayloadDto, LiveStatusEnum } from "./dto";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class HttpVerificationService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/verification', authService);
	}
	public getLiveStatusById(input: string): Observable<LiveStatusEnum>{
		return super.doPost(true, `/live_status_by_id/${input}`,input);
	}
}

